// src/context/CartContext.js
import React, { createContext, useContext, useState } from 'react';

// Kreiranje Context-a
const CartContext = createContext();

// Hook za lakše korišćenje Context-a
export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart mora biti korišćen unutar CartProvider');
  }
  return context;
};

// Provider komponenta
export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  // Funkcija za dodavanje proizvoda u košaricu
  const addToCart = (product) => {
    setCart(prevCart => {
      // Proverava da li proizvod već postoji u košarici
      const existingItem = prevCart.find(item => item.id === product.id);
      
      if (existingItem) {
        // Ako postoji, uvećava količinu
        return prevCart.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        // Ako ne postoji, dodaje novi proizvod sa količinom 1
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };

  // Funkcija za uklanjanje proizvoda iz košarice
  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId));
  };

  // Funkcija za ažuriranje količine
  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity === 0) {
      removeFromCart(productId);
      return;
    }
    
    setCart(prevCart =>
      prevCart.map(item =>
        item.id === productId
          ? { ...item, quantity: newQuantity }
          : item
      )
    );
  };

  // Funkcija za brisanje cele košarice
  const clearCart = () => {
    setCart([]);
  };

  // Funkcija za računanje ukupne cene
  const getTotalPrice = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  // Funkcija za računanje ukupnog broja proizvoda
  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  const value = {
    cart,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getTotalPrice,
    getTotalItems
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};